//
import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import { emailRegex, urlRegex, phoneRegex } from "./validationRegexes";
export function getIsFormValid(inputData) {
  return Object.keys(inputData).every(function (fieldName) {
    var item = inputData[fieldName];
    return !item.error;
  });
}
export function runValidations(value, validations) {
  var _this = this;

  var error = false;

  if (validations.length > 0) {
    // shortcircuit when first error is found
    validations.some(function (validation) {
      error = validation.apply(_this, [value]);
      return error;
    });
  }

  return error;
} // TODO: msidat: change validation functions to have client pass the error message

export var required = function required(value) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'This is a required field.';

  if (isEmpty(value)) {
    return message;
  }

  return false;
};
export var number = function number(value) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'This must be a number.';

  if (isNumber(parseInt(value, 10))) {
    return message;
  }

  return false;
};
export var email = function email(value) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Please enter a valid email address.';

  if (!isEmpty(value) && !value.match(emailRegex)) {
    return message;
  }

  return false;
};
export var url = function url(value) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Please enter a valid url.';

  if (!isEmpty(value) && !value.match(urlRegex)) {
    return message;
  }

  return false;
};
export var phoneNumber = function phoneNumber(value) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Please enter a valid phone number.';

  if (!isEmpty(value) && !value.match(phoneRegex)) {
    return message;
  }

  return false;
};
export var minLength = function minLength(min) {
  return function (value) {
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Must be at least ".concat(min, " characters.");

    if (isEmpty(value) || value.length < min) {
      return message;
    }

    return false;
  };
};
export var maxLength = function maxLength(max) {
  return function (value) {
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Must be no more than ".concat(max, " characters.");

    if (value.length > max) {
      return message;
    }

    return false;
  };
};
export var requiredLength = function requiredLength(len) {
  return function (value) {
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Must be exactly ".concat(len, " characters.");

    if (isEmpty(value) || !(value.length === len)) {
      return message;
    }

    return false;
  };
};